import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PreviewColumn, PreviewRow, ReportDefinition } from '@core/models';

@Component({
  selector: 'app-report-preview',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './report-preview.component.html',
  styleUrl: './report-preview.component.scss',
})
export class ReportPreviewComponent {
  @Input() visible = false;
  @Input({ required: true }) report!: ReportDefinition;
  @Input() title = '';
  @Input() description = '';
  @Input() icon = '';
  @Input() columns: PreviewColumn[] = [];
  @Input() rows: PreviewRow[] = [];
  @Input() totalRecords = 0;
  @Input() generating = false;

  @Output() closed = new EventEmitter<void>();
  @Output() downloadRequested = new EventEmitter<void>();
}